<div class="folder-tree" style="position: relative;">

  @if (loading) {
  <mat-spinner></mat-spinner>
  } @else {

  <div class="folder-tree-search">
    <mat-form-field appearance="outline" class="small">
      <mat-label>{{ 'sharePointBlock.filter' | translate }}</mat-label>
      <input matInput [formControl]="searchControl">
    </mat-form-field>
  </div>

  <div class="folder-tree-content" (scroll)="onScroll($event)">
    <ng-template #recursiveList let-list>
      <ul>
        @for (folder of list; track folder.id) {
        <li>
          <div class="row mx-0 sharepointFolder" [ngClass]="{'selected-folder': folder.id === selectedFolder?.id}">
            
            <div (click)="onFolderClicked(folder)" style="flex-grow:1;">
              
              @if(folder.hasChildren && folder.subFolders && folder.subFolders.length > 0) {
                <i class="col-auto fas fa-angle-down pr-1"></i>
              } @else if(folder.hasChildren) {
                <i class="col-auto fas fa-angle-right pr-1"></i>
              } @else {
                <i class="col-auto fas fa-angle-right pr-1 opacity-10"></i>
              }

              <i class="col-auto fas fa-folder folder-color"></i>

              <span class="col-auto">{{ folder.name }}</span>
            </div>

            <button mat-icon-button type="button" (click)="openInNewTab(folder.webUrl)" style="margin-left:auto;">
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
            </button>

            <button mat-icon-button type="button" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" (click)="$event.stopPropagation()">
              <!-- <mat-icon>more_vert</mat-icon> -->
              <i class="fa-solid fa-folder-plus mr-2"></i>
            </button>

            <mat-menu #menu="matMenu">
              <button mat-menu-item type="button" (click)="openFolderDialog(menuTrigger, folder)">
                <i class="fa-solid fa-folder-plus mr-2"></i>
                <span>{{ 'sharePointBlock.newSubFolder' | translate }}</span>
              </button>
            </mat-menu>
          </div>
          @if (folder.subFolders && folder.subFolders.length > 0) {
          <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: folder.subFolders }"></ng-container>
          }
        </li>
        }
      </ul>
    </ng-template>

    @if (visibleFolders.length > 0) {
    <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: visibleFolders }"></ng-container>
    }

    @if (loadingMore) {
    <ul class="skeleton-list">
      @for (_ of skeletonItems; track $index) {
      <li>
        <ngx-skeleton-loader [theme]="skeletonTheme"></ngx-skeleton-loader>
      </li>
      }
    </ul>
    }

  </div>

  <!-- @if (selectedFolder) {
    <div class="folder-tree-footer">
      <span style="display:block;margin-bottom:.5rem">
        <i class="fa-solid fa-folder-plus folder-color-new"></i> -->
        <!-- {{ 'sharePointBlock.newFolder' | translate }} -->
        <!-- {{ 'sharePointBlock.subFolder' | translate }} <strong>{{selectedFolder.name}}</strong>
      </span>

      <form (ngSubmit)="createFolder()">
        <div class="row" dense>
          <div class="col">
            <mat-form-field appearance="outline" class="small">
              <mat-label>{{ 'sharePointBlock.folderName' | translate }}</mat-label>
              <input matInput [(ngModel)]="folderName" name="newFolderName" required>
            </mat-form-field>
          </div>
          <div class="col-auto">
            <button mat-flat-button color="primary" type="submit" class="form-button" [disabled]="!folderName.trim()">{{ 'create' | translate }}</button>
          </div>
        </div>
      </form>


  </div>

  } -->
  }
</div>